import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseURL } from 'src/app/models/baseURL';

@Injectable({
  providedIn: 'root'
})
export class ComponentService {
  mainURL: string = 'api';
  constructor(private http: HttpClient) { }

  getComponent(type: string) {
    return this.http.get(`${baseURL}${this.mainURL}/gettype/${window.location.hostname}/${type}`);
  }
}
